import React, { useState, useEffect } from 'react';
import host from "../../global.jsx";
import Cookies from "js-cookie";
import axios from "axios";
import "../../css/HRPortal.css";

const AccountInfo = () => {
  const accessToken = Cookies.get("accessToken");
  const [adminName, setAdminName] = useState("");
  const [adminEmail, setAdminEmail] = useState("");
  const [adminContact, setAdminContact] = useState("");
  const [isEditingName, setIsEditingName] = useState(false);
  const [isEditingContact, setIsEditingContact] = useState(false);
  const [tempName, setTempName] = useState("");
  const [tempContact, setTempContact] = useState("");

  const displayConvAIAdminData = async () => {
    try {
      const response = await axios.get(`${host}/get_convai_admin_details`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      if (response) {
        setAdminName(response.data.admin_name);
        setAdminEmail(response.data.admin_email);
        setAdminContact(response.data.admin_contact);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const updateAdminDetails = async (field, value) => {
    try {
      const formData = new FormData();
      formData.append(field, value);
      
      await axios.put(`${host}/update_convai_admin_details`, formData, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "multipart/form-data",
        },
      });
      
      // Refresh data after update
      displayConvAIAdminData();
    } catch (error) {
      console.error("Error updating admin details:", error);
    }
  };

  const handleNameDoubleClick = () => {
    setTempName(adminName);
    setIsEditingName(true);
  };

  const handleContactDoubleClick = () => {
    setTempContact(adminContact);
    setIsEditingContact(true);
  };

  const handleNameSave = () => {
    if (tempName.trim() && tempName !== adminName) {
      updateAdminDetails("admin_name", tempName);
    }
    setIsEditingName(false);
  };

  const handleContactSave = () => {
    if (tempContact !== adminContact) {
      updateAdminDetails("admin_contact", tempContact);
    }
    setIsEditingContact(false);
  };

  const handleNameChange = (e) => {
    setTempName(e.target.value);
  };

  const handleContactChange = (e) => {
    setTempContact(e.target.value);
  };

  const handleKeyPress = (e, field) => {
    if (e.key === 'Enter') {
      if (field === 'name') {
        handleNameSave();
      } else if (field === 'contact') {
        handleContactSave();
      }
    } else if (e.key === 'Escape') {
      if (field === 'name') {
        setIsEditingName(false);
      } else if (field === 'contact') {
        setIsEditingContact(false);
      }
    }
  };

  useEffect(() => {
    displayConvAIAdminData();
  }, []);

  return (
    <div className="glass-effect p-6 rounded-lg flex flex-col items-center">
      <h2 className="custom-h3 text-white mb-4">Account Details</h2>
      
      {/* Admin Name - Editable */}
      <div className="w-full mb-4">
        <label className="block text-sm text-gray-300 mb-1">Name</label>
        {isEditingName ? (
          <div className="flex items-center gap-2">
            <input
              type="text"
              value={tempName}
              onChange={handleNameChange}
              onKeyDown={(e) => handleKeyPress(e, 'name')}
              className="w-full bg-gray-700 border border-gray-600 rounded px-3 py-1 text-white focus:ring-2 focus:ring-blue-400 focus:border-transparent"
              autoFocus
            />
            <button
              onClick={handleNameSave}
              className="bg-green-600 hover:bg-green-700 text-white px-3 py-1 rounded text-sm"
            >
              ✓
            </button>
            <button
              onClick={() => setIsEditingName(false)}
              className="bg-red-600 hover:bg-red-700 text-white px-3 py-1 rounded text-sm"
            >
              ✗
            </button>
          </div>
        ) : (
          <div
            onDoubleClick={handleNameDoubleClick}
            className="cursor-pointer p-2 bg-gray-700/50 rounded hover:bg-gray-600/50 transition-colors"
          >
            <p className="text-white">{adminName || "Not set"}</p>
            <p className="text-xs text-gray-400 mt-1">Double-click to edit</p>
          </div>
        )}
      </div>

      {/* Admin Email - Read Only */}
      <div className="w-full mb-4">
        <label className="block text-sm text-gray-300 mb-1">Email</label>
        <div className="p-2 bg-gray-700/50 rounded">
          <p className="text-white">{adminEmail || "Not set"}</p>
          <p className="text-xs text-gray-400 mt-1">Email cannot be changed</p>
        </div>
      </div>

      {/* Admin Contact - Editable */}
      <div className="w-full">
        <label className="block text-sm text-gray-300 mb-1">Contact</label>
        {isEditingContact ? (
          <div className="flex items-center gap-2">
            <input
              type="text"
              value={tempContact}
              onChange={handleContactChange}
              onKeyDown={(e) => handleKeyPress(e, 'contact')}
              className="w-full bg-gray-700 border border-gray-600 rounded px-3 py-1 text-white focus:ring-2 focus:ring-blue-400 focus:border-transparent"
              autoFocus
            />
            <button
              onClick={handleContactSave}
              className="bg-green-600 hover:bg-green-700 text-white px-3 py-1 rounded text-sm"
            >
              ✓
            </button>
            <button
              onClick={() => setIsEditingContact(false)}
              className="bg-red-600 hover:bg-red-700 text-white px-3 py-1 rounded text-sm"
            >
              ✗
            </button>
          </div>
        ) : (
          <div
            onDoubleClick={handleContactDoubleClick}
            className="cursor-pointer p-2 bg-gray-700/50 rounded hover:bg-gray-600/50 transition-colors"
          >
            <p className="text-white">{adminContact || "Not set"}</p>
            <p className="text-xs text-gray-400 mt-1">Double-click to edit</p>
          </div>
        )}
      </div>

      <p className="font-bold text-gray-400 mt-4">Admin</p>
    </div>
  );
};

export default AccountInfo;
